import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';
import styles from './ComingSoon.module.css';

function titleCase(str) {
  return str
    .split('-')
    .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
    .join(' ');
}

export default function ComingSoon({ explicitTitle }) {
  const { slug } = useParams();
  const pageTitle = explicitTitle || (slug ? titleCase(slug) : 'Products');
  const fullTitle = `${pageTitle} – Coming Soon`;

  return (
    <div className={styles.container}>
      <Helmet>
        <title>{fullTitle} - ABC Railing</title>
        <meta
          name="description"
          content={`${pageTitle} page is coming soon. Explore our railings, staircases, metal fencing, and custom fabrications soon.`}
        />
      </Helmet>

      <div className={styles.card}>
        <h1 className={styles.title}>{pageTitle}</h1>
        <p className={styles.subtitle}>This page is under construction. Check back soon for product details, specs, and galleries.</p>
        <div className={styles.ctaRow}>
          <a className={styles.primaryCta} href="/portfolios">View Portfolios</a>
          <a className={styles.secondaryCta} href="/contact">Contact Us</a>
        </div>
      </div>
    </div>
  );
}